import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import Spinner from '../../components/generics/Spinner';

import queryString from 'query-string';
import ReactPaginate from 'react-paginate';

import ReportHeader from '../../components/generics/ReportHeader';
import Filter from '../../components/generics/Filter';
import ReportProduction from '../../components/reports/ReportProduction';

import NoPermissionMessage from '../../components/generics/NoPermissionMessage';

import { fetchStations, fetchStationsSuccess, fetchStationsFailure } from "../../store/sessions/actions";
import { fetchProductionReport, fetchProductionReportSuccess, fetchProductionReportFailure } from "../../store/reports/actions";

import { fetchProductionReportCSV } from '../../store/reports/api';

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class ReportProductionContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);
    this.state = {
      filterFrom: moment().subtract(1, 'week').format('YYYY-MM-DD'),
      filterTo: moment().format('YYYY-MM-DD'),
      searchVal: '',
      selectedStation: undefined,
      selectedStationIndex: undefined,
      selectedParent_Child: undefined,
      plant: '',
      lot: '',
    };

    this.changeSearch =_.debounce(() => {
      this.searchRefresh();
      this.updateQueryString();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const filterFrom = params.from ? params.from : this.state.filterFrom;
    const filterTo = params.to ? params.to : this.state.filterTo;
    const searchVal = params.inventory ? params.inventory : undefined;
    const selectedStation = params.selectedStation ? params.selectedStation : undefined;
    const selectedStationIndex = params.selectedStationIndex ? params.selectedStationIndex : undefined;
    const selectedParent_Child = params.parent_Child ? params.parent_Child : undefined;
    const page = params.page ? params.page : STARTING_PAGE;
    const plant = params.plant ? params.plant : this.state.plant;
    const lot = params.lot ? params.lot : this.state.lot;

    // Fetch initial page
    this.setState({
      page, filterFrom, filterTo, searchVal, selectedStation, selectedStationIndex,
      selectedParent_Child, plant, lot
    }, () => {
      this.props.getProductionReport(
        page,
        searchVal,
        filterFrom,
        filterTo,
        selectedStation,
        selectedParent_Child,
        plant,
        lot);
    });

    // Fetch stations
    if (!this.props.stationsList || this.props.stationsList.length === 0) {
      this.props.fetchStations();
    }
  }

  // ---------------------------------------------------------------------------
  // Filters handling
  // ---------------------------------------------------------------------------

  onFromDateChange = (event) => {
    let filterFrom = event.target.value ? event.target.value : this.state.filterFrom;
    this.setState({ filterFrom, page: STARTING_PAGE }, () => {
      this.updateQueryString();
      this.searchRefresh();
    });
  };

  onToDateChange = (event) => {
    let filterTo = event.target.value ? event.target.value : this.state.filterTo;
    this.setState({ filterTo, page: STARTING_PAGE }, () => {
      this.updateQueryString();
      this.searchRefresh();
    });
  };

  onSearchChange = (event) => {
    let searchVal = event.target.value ? event.target.value : '';
    this.setState({ searchVal, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  onStationChange = (event) => {
    let selectedStationIndex = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined,
        selectedStation = selectedStationIndex ? this.props.stations[selectedStationIndex].id : undefined;
    this.setState({ selectedStation, selectedStationIndex }, () => {
      this.searchRefresh();
      this.updateQueryString();
    });
  };

  onParent_ChildChange = (event) => {
    let selectedParent_Child = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined;
    this.setState({ selectedParent_Child }, () => {
      this.searchRefresh();
      this.updateQueryString();
    });
  };


  onPlantChange = (event) => {
    const plant = event.target.value ? event.target.value : "";
    this.setState({ plant }, () => {
      this.changeSearch()
    });
  };

  onLotChange = (event) => {
    const lot = event.target.value ? event.target.value : "";
    this.setState({ lot }, () => {
      this.changeSearch()
    });
  };

  searchRefresh = () => {
    const { page, searchVal, filterFrom, filterTo, selectedStation, selectedParent_Child, plant, lot } = this.state;
    this.props.getProductionReport(page, searchVal, filterFrom, filterTo, selectedStation, selectedParent_Child, plant, lot);
  };

  updateQueryString = () => {
    const { page, searchVal, filterFrom, filterTo, selectedStation, selectedStationIndex, selectedParent_Child, plant, lot } = this.state;
    let params = {};
    if (filterFrom) params.from = filterFrom;
    if (filterTo) params.to = filterTo;
    if (searchVal) params.inventory = searchVal;
    if (selectedParent_Child) params.parent_Child = selectedParent_Child;
    if (selectedStation) params.selectedStation = selectedStation;
    if (selectedStationIndex) params.selectedStationIndex = selectedStationIndex;
    if (plant) params.plant = plant;
    if (lot) params.lot = lot;
    params.page = page;
    this.props.history.push({
      search: queryString.stringify(params)
    })
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.updateQueryString();
          this.searchRefresh();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // CSV
  // ---------------------------------------------------------------------------

  loadCsv = () => {
    const { searchVal, filterFrom, filterTo, selectedStation, selectedParent_Child, plant, lot} = this.state;
    let fileName = `${moment(filterFrom).format("MMM DD")}-${moment(filterTo).format("MMM DD")}.csv`;
    this.setState({
      csvIsloading: true,
    });
    fetchProductionReportCSV(searchVal, filterFrom, filterTo, selectedStation, selectedParent_Child, plant, lot)
      .then((r) => {
        let blob = new Blob([r.data], { type: "text/csv" });
        let link = document.createElement("a");
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        link.click();
        document.body.removeChild(link);
        this.setState({
          csvIsloading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          csvIsloading: false,
        });
      });
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if (!this.state.filterFrom || !this.state.filterTo){
      return <Spinner />;
    } else {
      return (
        <div>
          <div className="card mb-2">
            <ReportHeader title='Production Report'
                          actionTitle='Export CSV'
                          actionClass='btn btn-primary m-0'
                          csvLoading={this.state.csvIsloading}
                          fromFile={true}
                          loadCsv={this.loadCsv}/>
            <Filter
              searchLabel="Search"
              searchPlaceholder="Item name"
              searchVal={this.state.searchVal}
              onSearchChange={this.onSearchChange}
              dateLabel="From Date"
              dateVal={this.state.filterFrom}
              onDateChange={this.onFromDateChange}
              dateLabel2="To Date"
              dateVal2={this.state.filterTo}
              onDateChange2={this.onToDateChange}
              dropdownLabel="Session Station"
              dropdownPlaceholder="Select"
              dropdownVal={this.state.selectedStationIndex}
              onDropdownChange={this.onStationChange}
              dropdownOptions={this.props.stations}
              dropdownLabel2="Parent/Child"
              dropdownPlaceholder2="Both"
              dropdownVal2={this.state.selectedParent_Child}
              dropdownByElement2
              onDropdownChange2={this.onParent_ChildChange}
              dropdownOptions2={["Parent", "Child"]}
              colClass="col-12 col-sm-3"
              searchLabel3="Plant"
              searchPlaceholder3="Search by plant"
              searchVal3={this.state.plant}
              onSearchChange3={this.onPlantChange}
              searchLabel4="Lot"
              searchPlaceholder4="Search by lot"
              searchVal4={this.state.lot}
              onSearchChange4={this.onLotChange}
            />

          </div>
          <ReportProduction productionList={this.props.productionReport.production}/>
          {this.props.productionReport.pages > 1 &&
            <ReactPaginate pageCount={this.props.productionReport.pages}
                            pageRangeDisplayed={2}
                            marginPagesDisplayed={1}
                            previousLabel="<"
                            nextLabel=">"
                            onPageChange={this.handlePageRequest}
                            initialPage={this.state.page-1}
                            disableInitialCallback={true}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            activeClassName="page-item active"
                            previousClassName="paginate_button previous"
                            nextClassName="paginate_button next"
                            disabledClassName="page-item disabled"
                            forcePage={this.state.page-1}/>
          }
          {this.props.productionReport.loading ? <Spinner /> : null}
        </div>
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    productionReport: state.reports.productionReport,
    currentUser: state.auth.currentUser,
    stations: state.sessions.stationsList.stations.results
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProductionReport: (page, search='', from, to, station, parent_Child=undefined, plant, lot) => {
      dispatch(fetchProductionReport(page, search, from, to, station, parent_Child, plant, lot)).payload.then((response) => {
        dispatch(fetchProductionReportSuccess(response.data));
      }, (error) => {
        dispatch(fetchProductionReportFailure(error));
      });
    },
    fetchStations: () => {
      dispatch(fetchStations()).payload.then((response) => {
        dispatch(fetchStationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchStationsFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportProductionContainer));
